import React, { useEffect, useRef } from "react";

type MccResizeObserverProps = {
  frameId: string;
  element: React.ReactNode;
};

function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>;

  return function (...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export default function MccResizeObserver({
  frameId,
  element,
}: MccResizeObserverProps) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const observer = new ResizeObserver(
      debounce((entries) => {
        if (!entries || entries.length < 1) {
          return;
        }

        const entry = entries[0];
        const data = {
          type: "mcc-form-resized",
          frameId: frameId,
          rect: {
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          },
        };

        window.parent.postMessage(data, "*");
      }, 200)
    );

    observer.observe(container);

    return () => observer.disconnect();
  }, [frameId]);

  return (
    <>
      <div ref={containerRef}>{element}</div>
    </>
  );
}
